import React, { FC } from 'react';
import { Dialog, DialogContent, DialogActions, Button } from '@lesmills-international/components';

interface ErrorDialogProps {
  open: boolean;
  onClose: () => void;
  errorMessage: string;
  buttonText?: string;
}

const ErrorDialog: FC<ErrorDialogProps> = ({
  open,
  onClose,
  errorMessage,
  buttonText = 'OK'
}) => (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(0, 0, 0, 0.2)', // Very transparent - users can see workout content
        },
      }}
      PaperProps={{
        style: {
          width: 'clamp(280px, 90vw, 500px)',
          maxWidth: '90vw',
          margin: '16px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)', // Add shadow for dialog visibility
        }
      }}
    >
      <DialogContent>
        <div
          style={{
            padding: 'clamp(8px, 2vw, 16px) clamp(16px, 4vw, 24px)',
            textAlign: 'left', // 🎨 FIX: Left-aligned text for better readability
          }}
        >
          <span style={{ 
            fontSize: 'clamp(14px, 4vw, 18px)', 
            lineHeight: '1.5',
            wordBreak: 'break-word',
          }}>
            {errorMessage}
          </span>
        </div>
      </DialogContent>
      <DialogActions>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end', // Right-aligned for single button
            width: '100%',
            padding: 'clamp(8px, 2vw, 16px) clamp(16px, 4vw, 24px)',
          }}
        >
          <Button
            style={{ 
              borderRadius: '100px',
              minWidth: 'clamp(80px, 20vw, 120px)',
              fontSize: 'clamp(14px, 3.5vw, 16px)',
              padding: 'clamp(8px, 2vw, 12px) clamp(16px, 4vw, 24px)',
            }}
            onClick={onClose}
          >
            {buttonText}
          </Button>
        </div>
      </DialogActions>
    </Dialog>
);

export default ErrorDialog;
